import getLocalString from "constants/Localization";
import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { TransferTruck } from "generated/graphql";
import { GlobalMessage } from "hooks/notifications/useGlobalMessage";
import useDeleteTransferTruck from "hooks/organization/useDeleteTransferTruck";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function Delete({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: TransferTruck["id"];
}) {
  const [deleteTransferTruck, { isSuccess }] = useDeleteTransferTruck();

  const acceptFn = useCallback(async (): Promise<GlobalMessage> => {
    const { data } = await deleteTransferTruck({ variables: { id } });

    if (isSuccess(data)) {
      closeMenu();
      return { message: getLocalString("organization.delete-transfer-truck-success") };
    } else {
      return {
        message: getLocalString("organization.delete-transfer-truck-failure"),
        options: { variant: "error" },
      };
    }
  }, [deleteTransferTruck, id]);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Confirmation"
        content="Are you sure you want to delete this transfer truck?"
      />
      <MenuItem onClick={() => setOpen(true)}>Delete</MenuItem>
    </>
  );
}
